import type { FaireProductEntity } from "../../entity_types/product";

export const p_xrmqatasmy: FaireProductEntity = {
  token: "p_xrmqatasmy",
  type: "product",
  name: "I ❤️ Cheese Gym Crew Socks - Foodie Gift",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/3e986a65585911367943b91f70da58eb03d84f0d8d91adfd09727f9838daad6c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3fbfb3cb5a5fe3eac0827406d84553e74ecaa090699af92d145ddbdc40c664d9.jpeg",
    "https://cdn.faire.com/fastly/5ac257750f7577d9046e188be49359791000a94f17a504a327b3f82a77efad3c.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/dedd7a980b7d7269c3955e5cafd4ba6fc6e7fe017096af050609f8ce5459fb14.jpeg"
  ],
  priceDollars: 6.75,
  description: "Whether you like it imported from France and paired with fine wine or slathered over nachos and stuffed indiscriminately into your slacked jaw , we're all on #teamcheese.\n\nThese babies feel softer than Brie, but look HOT like Pepper Jack 🔥  🧀 🤤\n\nThe ultimate foodie gift for cheese lovers—these socks are a hit in gourmet shops, wine boutiques, cheese counters, and anywhere that celebrates dairy devotion. A fun add-on for wine and cheese nights or food-themed gift displays.\n\nKey features of our I ❤️ Cheese gym socks:\n\n• Unisex sizing\n• One size fits most \n• Comfy cushion foot\n• No toe seam\n• Made with high quality cotton in the USA\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:28:06.938Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
